import React from "react";
import { BottomRight, TopLeftIcon } from "../../asset";
import { useSelector } from "react-redux";
import LottieControl from "./LottieControl";

const WelcomePage = () => {
  const { firstName, lastName, userId } = useSelector((state) => state.auth);
  return (
    <div className="flex flex-col justify-center items-center mt-[3.75rem]">
      <div className="bg-white-100 rounded-[10px] w-[97.25rem] h-[44.188rem] flex flex-row">
        <div className=" w-1/2 flex flex-col">
          <div className="flex flex-row">
            <img src={TopLeftIcon} alt="img-top-left" />
            <div className="-ml-[16.75rem] mt-[30px]">
              <p className=" font-sans-bold text-[2.625rem] ">
                {" "}
                Welcome to GroLog,{" "}
              </p>
              <p className=" font-sans-bold text-[2.625rem] -mt-5">
                {" "}
                Your Logistic Solution Partner{" "}
              </p>
            </div>
          </div>
          <div className=" ml-[40px] font-roboto mt-5">
            <p className=" text-xl font-normal text-[#1D1D1D]">Hello,</p>
            <p className="font-sans text-[28px]">
              <span className="font-normal"> {`${userId} - `}</span>
              <span className="font-bold">{`${firstName} ${lastName}`}</span>
            </p>
          </div>
        </div>
        <div className=" w-1/2 grid grid-cols place-items-end">
          <div className="-mb-[30rem] mr-10">
            <LottieControl />
          </div>
          <img src={BottomRight} alt="img-bottom" className="-mt-40" />
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
